import { useQuery } from "@apollo/client";
import {
  Citation,
  CitationDocumentManyQuery,
  CitationDocumentManyQueryVariables,
  CitationNoteManyQuery,
  CitationNoteManyQueryVariables,
} from "_graphql-types-frontend/graphql";

import { DOCUMENT_MANY, NOTE_MANY } from "./graphql";

export default function CitationDisplay({
  citations,
}: {
  citations: Citation[];
}) {
  return (
    <ul>
      <DocumentsDisplay
        documentIds={citations
          .filter(c => c.type === "Document")
          .map(c => c.id)}
      />
      <NotesDisplay
        notesIds={citations.filter(c => c.type === "Note").map(c => c.id)}
      />
    </ul>
  );
}

const DocumentsDisplay = ({ documentIds }: { documentIds: number[] }) => {
  if (documentIds.length === 0) {
    return <></>;
  }
  const { data, loading, error } = useQuery<
    CitationDocumentManyQuery,
    CitationDocumentManyQueryVariables
  >(DOCUMENT_MANY, {
    variables: { documentIds },
  });

  if (loading) return <div>Loading documents...</div>;
  if (error) return <div>Error loading documents.</div>;

  return data?.documentMany.map(
    doc =>
      doc && (
        <li key={`doc_${doc.id}`}>
          <a href={doc.signedUrl!} target="_blank" rel="noopener noreferrer">
            {doc.name}
          </a>
        </li>
      )
  );
};

const NotesDisplay = ({ notesIds }: { notesIds: number[] }) => {
  if (notesIds.length === 0) {
    return <></>;
  }
  const { data, loading, error } = useQuery<
    CitationNoteManyQuery,
    CitationNoteManyQueryVariables
  >(NOTE_MANY, {
    variables: { noteIds: notesIds },
  });

  if (loading) return <div>Loading notes...</div>;
  if (error) return <div>Error loading notes.</div>;

  return data?.notesMany.map(
    note =>
      note && (
        <li key={`note_${note.id}`}>
          Note: {note.noteDate} {note.text?.slice(0, 50)}...
        </li>
      )
  );
};
